import { render, staticRenderFns } from "./ClientViewClientPlanCard.vue?vue&type=template&id=0595965e&"
import script from "./ClientViewClientPlanCard.vue?vue&type=script&lang=js&"
export * from "./ClientViewClientPlanCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports